import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import caretDown from "../assets/img/caret-down.svg";
/* import { ArrowRightCircle } from 'react-bootstrap-icons'; */
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { useTranslation } from "react-i18next";

export const Banner = () => {
  const [t,i18n] = useTranslation("global");

  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Frontend Developer.", "React Next Typescript."];
  const period = 2000;
  const [status,setStatus] = useState('es')
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""} >
                <div className="container-welcome">
                <span className="tagline">{t("banner.welcome")}</span>
                 <div className="lang-menu lang-button" style={{zIndex:999}}>
                <div className={status === "en" ? "selected-lang en"  : "selected-lang sp"}>
                </div>
                <span>{status === "en" ? "English" : "Español"}</span>
                <img className="caret-down"src={caretDown} alt="" />
                <ul>
                    <li>
                        <a  onClick={()=>{i18n.changeLanguage("es");setStatus('es')}} className="sp">Español</a>
                    </li>
                    <li>
                        <a  onClick={()=>{i18n.changeLanguage("en");setStatus('en')}} className="en">English</a>
                    </li>
{/*                     <li>
                        <a onClick={()=>i18n.changeLanguage("dk")}  className="dk">Dansk</a>
                    </li> */}
                </ul>
                </div> 
                </div>
               

                <h1>{t("banner.im") } <span className="txt-rotate"/*  dataPeriod="1000" */ data-rotate='[ "Web Developer", "Web Designer", "UI/UX Designer" ]'><span className="wrap">{text}</span></span></h1>
                  <p>{t("banner.about")}</p>
                  {/* <button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={25} /></button> */}
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn banner__img" : ""}>
                  <img src={headerImg} id="headerImg" alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
               {/*  <div className="lang-menu lang-button">
                <div className="selected-lang">
                </div>
                <span>Español</span>
                <img className="caret-down"src={caretDown} alt="" />
                <ul>
                    <li>
                        <a href="#" className="sp">Español</a>
                    </li>
                    <li>
                        <a href="" className="en">English</a>
                    </li>
                    <li>
                        <a href="" className="dk">Dansk</a>
                    </li>
                </ul>
                </div> */}